import { PP_RUNNER_MODIFIER_EVENT } from "@tvg/ts-types/Gtm";
import { capitalize } from "lodash";
import mediator from "@tvg/mediator";
import {
  RunnerModifierEnum,
  RunnerSortOrderEnum,
  RunnerSortByEnum
} from "../../types";

interface GtmApplyFilterPayload {
  filter: RunnerModifierEnum;
  trackName: string;
}

interface GtmApplySortPayload {
  sortOperation: RunnerSortOrderEnum;
  sortValue: RunnerSortByEnum;
  trackName: string;
  raceNumber: string;
}

export const gtmOnFilterApplied = ({
  filter,
  trackName
}: GtmApplyFilterPayload) => {
  mediator.base.dispatch({
    type: PP_RUNNER_MODIFIER_EVENT.APPLY_FILTER,
    payload: {
      trackName,
      filter: capitalize(filter.toString())
    }
  });
};

export const gtmOnSortApplied = ({
  sortOperation,
  sortValue,
  trackName,
  raceNumber
}: GtmApplySortPayload) => {
  mediator.base.dispatch({
    type: PP_RUNNER_MODIFIER_EVENT.APPLY_SORT,
    payload: {
      sortOperation:
        sortOperation === RunnerSortOrderEnum.ASC ? "Ascending" : "Descending",
      sortValue,
      trackName,
      raceNumber
    }
  });
};
